/**
 * function so we can use dot notation to access object fields in regular objects
 */
export var getDotNotationValue = function (obj, str) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return str.split(".").reduce(function (o, i) { return o === null || o === void 0 ? void 0 : o[i]; }, obj);
};
